import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	repositoryLabel: {
		id: 'search-result.repository-label',
		defaultMessage: 'Repository',
		description: 'Repository metadata label',
	},
});
